import { countOverdueInvoices, overdueInvoices, startOfToday } from '@reos/today-metrics';

/**
 * Krok UXR1 — „Čeká na mě" na JEDNOM miste.
 *
 * Pocty u polozek menu (Smlouvy, Fakturace) a u zvonku v hlavicce musi rikat
 * totez, co blok „Čeká na mě" na Dnesku. Driv to byly dva ruzne dotazy ve
 * dvou souborech, takze se cisla mohla rozejit (a shell by data stahoval
 * podruhe). Klice react-query jsou proto spolecne a definice „po splatnosti"
 * je jedna funkce (krok AS2: presunuta do `@reos/today-metrics`, aby ji mohl
 * pocitat i `reos.today` v `apps/mcp-gateway`).
 */

export const AWAITING_SIGNATURE_QUERY_KEY = ['waiting-for-me', 'contracts', 'awaiting-signature'] as const;

/**
 * Krok SML1 bod 1 — ODZNAK „Smlouvy" V MENU je pocet smluv „Na tobě".
 *
 * Zadani: „Odznak »Smlouvy« v menu = počet »Na tobě« z téže funkce." Ta funkce
 * je `contractStandings` v `lib/contract-standing.ts` a bere DVE veci: radky
 * smluv a skutecne podepisovani. Oba klice jsou tady, aby je menu a prehled
 * stahovaly jednou a nemohly rict jine cislo.
 */
export const ALL_CONTRACTS_QUERY_KEY = ['waiting-for-me', 'contracts', 'all'] as const;
/**
 * Krok SIGN1 bod 3: podepsane smlouvy. Dnesek z nich bere TY DNESNI („stáhnout
 * podepsanou smlouvu" misto „podepsat"); klic je tady, aby si ho pripadny
 * druhy cten (menu, prehled) stahoval jednou jako ostatni.
 */
export const SIGNED_CONTRACTS_QUERY_KEY = ['waiting-for-me', 'contracts', 'signed'] as const;
export const SIGNATURE_SESSIONS_QUERY_KEY = ['waiting-for-me', 'contracts', 'signature-sessions'] as const;
export const ISSUED_INVOICES_QUERY_KEY = ['waiting-for-me', 'invoices', 'issued'] as const;
/**
 * Krok LIST1 bod 3: inzeraty, u kterych ceka potvrzeni stavu po rezervaci nebo
 * prodeji. Klic je tady ze stejneho duvodu jako ostatni — dlazdice „Na tobě",
 * veta pod ni i pripadny odznak musi mluvit o tomtez seznamu.
 */
export const LISTING_DEAL_OFFERS_QUERY_KEY = ['waiting-for-me', 'listing-deals', 'offers'] as const;

/**
 * Krok TAB1 bod 1: dnešní úkoly jsou od teď taky sdílená data — odznak u
 * položky „Úkoly“ v menu a dlaždice „Na tobě“ na Dnešku z nich počítají
 * TOTÉŽ číslo (`overdueTaskCount` v `@reos/today-metrics`). Klíč nese
 * `ownerUserId`, protože Dnešek se ptá jen na své úkoly a menu musí ukázat
 * stejný výsek.
 */
export function todayTasksQueryKey(ownerUserId: string | null): readonly unknown[] {
  return ['waiting-for-me', 'tasks', 'today', ownerUserId];
}

export { startOfToday, overdueInvoices, countOverdueInvoices };
